import axios from 'axios';
import { isProductionEnvironment, isStageEnvironment } from 'utils/environment';
import { DeliveryBoardItem } from 'views/delivery-board/types/delivery-board-model.type';
import { DeliveryBoardItems } from '../mock/delivery-board-items.mock';

// GET
// /ewosapi/v1/delivery-board/{customerErpId}
export const getDeliveryBoardItems = async (customerErpId: string): Promise<DeliveryBoardItem[]> => {
  if (!isProductionEnvironment && !isStageEnvironment) return DeliveryBoardItems;
  const res = await axios.get<DeliveryBoardItem[]>(`/ewosapi/v1/delivery-board/${customerErpId}`);
  return res.data;
};

// GET
// ewosapi/v1/delivery-board/{customerErpId}/document?orderNumber={orderNumber}&documentId={documentId}
export const downloadOrderDocuments = async (customerErpId: string, orderNumber: string, documentId: string): Promise<Blob> => {
  const res = await axios.get(
    `ewosapi/v1/delivery-board/${customerErpId}/document?orderNumber=${orderNumber}&documentId=${documentId}`,
    {
      responseType: 'blob',
    }
  );
  return res.data;
};
